var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 356.62 356.62",
    style: {
      enableBackground: "new 0 0 356.62 356.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.31,0C79.99,0,0,79.99,0,178.311S79.99,356.62,178.31,356.62s178.31-79.989,178.31-178.31S276.63,0,178.31,0z  M178.31,326.62C96.532,326.62,30,260.089,30,178.311S96.532,30,178.31,30s148.31,66.532,148.31,148.311 S260.088,326.62,178.31,326.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.31,66.949c-35.58,0-64.527,28.947-64.527,64.527c0,8.284,6.716,15,15,15s15-6.716,15-15 c0-19.038,15.489-34.527,34.527-34.527s34.527,15.489,34.527,34.527s-15.489,34.527-34.527,34.527c-8.284,0-15,6.716-15,15v33.915 c0,8.284,6.716,15,15,15s15-6.716,15-15v-20.675c28.371-6.779,49.527-32.35,49.527-62.768 C242.837,95.896,213.89,66.949,178.31,66.949z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.31,
    cy: 265.899,
    r: 20.999
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question_icon.6418869341d4e3af8cfb616ea12f3f7b.svg";
export { ForwardRef as ReactComponent };